export default __webpack_public_path__ + "static/media/36I-114283_-20941_0.3e5f8ed9.jpg";